import { useState } from "react";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import Logger from "@/lib/logger.ts";
import { notifyError } from "@/lib/notifications.ts";
import { forceDownloadFile } from "../utils/download.ts";

export default function useForceDownloadFile() {
    const [isPending, setIsPending] = useState<boolean>(false);

    const download = async (fileUrl: string) => {
        try {
            setIsPending(true);
            await forceDownloadFile(fileUrl);
        } catch (err) {
            notifyError("Could not download file");
            Logger.error("Could not download file", err);
            DiagnosticsStore.collectEventLog("error", `Could not download ${fileUrl}`);
        } finally {
            setIsPending(false);
        }
    };

    return { isPending, download };
}
